<template>
  <v-container id="profile-container" class="profile-main">
    <div class="boxes">
      <div class="maintitle">{{ $t("Profile.Title") }}</div>
      <loading
        v-if="isLoading"
        :showLoading="true"
        class="loading-component"
      ></loading>
      <!-- commercials row -->
      <!-- <v-row class="row-boxes" v-if="!showCommercialRequest"> -->
      <v-row class="row-boxes" v-if="!showCommercialRequest && !isLoading">
        <v-col
          cols="12"
          xs="6"
          class="lg2-custom custom-vertical-boxes-container"
        >
          <commercialbox
            v-for="(commercial_d, index) in commercials_d"
            :key="index"
            :item="commercial_d"
            color="#D94D00"
            :component_class="getClass(commercials_d, index)"
          ></commercialbox>

          <commercialbox
            v-if="commercials_d.length == 0"
            :item="emptyItem"
            color="#D94D00"
            :img_name="divisions[0].img_name"
            :title="divisions[0].title"
            divisionId="1"
            component_class="nocommercial"
            :isProfile="true"
          ></commercialbox>
        </v-col>
        <!-- <v-col
          cols="12"
          xs="6"
          class="lg5-custom custom-vertical-boxes-container"
        >
          <commercialbox
            v-for="(commercial_t, index) in commercials_t"
            :key="index"
            :item="commercial_t"
            color="#00489B"
            :component_class="getClass(commercials_t, index)"
          ></commercialbox>

          <commercialbox
            v-if="commercials_t.length == 0"
            :item="emptyItem"
            color="#00489B"
            :img_name="divisions[1].img_name"
            :title="divisions[1].title"
            component_class="nocommercial"
            divisionId="2"
            :isProfile="true"
          ></commercialbox>
        </v-col>
        <v-col
          cols="12"
          xs="6"
          class="lg5-custom custom-vertical-boxes-container"
        >
          <commercialbox
            v-for="(commercial_a, index) in commercials_a"
            :key="index"
            :item="commercial_a"
            color="#008EE9"
            :component_class="getClass(commercials_a, index)"
          ></commercialbox>

          <commercialbox
            v-if="commercials_a.length == 0"
            :item="emptyItem"
            color="#008EE9"
            :img_name="divisions[2].img_name"
            :title="divisions[2].title"
            component_class="nocommercial"
            divisionId="3"
            :isProfile="true"
          ></commercialbox>
        </v-col> -->
        <v-col
          cols="12"
          xs="6"
          class="lg2-custom custom-vertical-boxes-container"
        >
          <commercialbox
            v-for="(commercial_l, index) in commercials_l"
            :key="index"
            :item="commercial_l"
            color="#279A47"
            :component_class="getClass(commercials_l, index)"
          ></commercialbox>
          <commercialbox
            v-if="commercials_l.length == 0"
            :item="emptyItem"
            color="#279A47"
            :img_name="divisions[3].img_name"
            :title="divisions[3].title"
            component_class="nocommercial"
            divisionId="4"
            :isProfile="true"
          ></commercialbox>
        </v-col>
        <!-- <v-col
          cols="12"
          xs="6"
          class="lg5-custom custom-vertical-boxes-container"
        >
          <commercialbox
            v-for="(commercial_s, index) in commercials_s"
            :key="index"
            :item="commercial_s"
            color="#E7B444"
            :component_class="getClass(commercials_s, index)"
          ></commercialbox>

          <commercialbox
            v-if="commercials_s.length == 0"
            :item="emptyItem"
            color="#E7B444"
            :img_name="divisions[4].img_name"
            :title="divisions[4].title"
            component_class="nocommercial"
            divisionId="5"
            :isProfile="true"
          ></commercialbox>
        </v-col> -->
      </v-row>

      <!-- commercial request -->
      <v-row v-if="showCommercialRequest">
        <v-col class="show-request-container">
          <commercialbox
            :color="commercialRequest.color"
            :item="commercialRequest.item"
            component_class="full-commercial"
            :isProfile="true"
            :showTerm="true"
          ></commercialbox>
        </v-col>
      </v-row>
    </div>

    <!-- user data row -->
    <div class="boxes userdata" v-if="showUserData()">
      <v-row>
        <v-col cols="12">
          <userdata></userdata>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<style>
.profile-main .row.row-boxes {
  /* margin-top: 29px; */
  height: 470px;
}

.profile-main .boxes {
  height: auto;
  margin: 50px 46px 0 46px !important;
}

.profile-main .lg5-custom.custom-vertical-boxes-container {
  padding-top: 0;
  padding-bottom: 0;
  height: 100%;
}

.profile-main .partial-commercial {
  position: relative;
  height: 470px;
}

.partial-commercial .test {
  position: relative;
}

.custom-vertical-boxes > .item:last-child {
  padding-bottom: 0;
}

.custom-vertical-boxes > .item {
  position: relative;
}

.custom-vertical-boxes-num-items-1 > .item {
  height: 30px;
  padding-bottom: 10px;
}

.custom-vertical-boxes-num-items-2 > .item {
  height: 30px;
  padding-bottom: 10px;
}

.custom-vertical-boxes-num-items-3 > .item {
  height: 30px;
  padding-bottom: 10px;
}

.loading-component {
  height: 470px;
  position: relative;
}

@media (max-width: 600px) {
  .profile-main {
    padding-top: 126px;
  }

  .profile-main .row.row-boxes {
    margin-top: 16px;
    height: auto;
  }

  .profile-main .boxes {
    height: auto;
    margin: 0px 0px 0 0 !important;
  }

  .profile-main .maintitle {
    font: normal normal bold 20px/24px Roboto !important;
    color: #5d6367;
    margin: 16px 0 16px 0 !important;
  }

  .profile-main .show-request-container {
    padding-top: 16px;
  }

  .generic-button {
    font: normal normal bold 20px/24px Roboto !important;
  }

  .rounded-div {
    border-width: 3px !important;
  }
}
</style>
<script>
import loading from "../components/loadingComponent.vue";
import { Trans } from "@/plugins/Translation";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import commercialbox from "../components/commercialBox.vue";
import userdata from "../components/userData.vue";

export default {
  components: {
    loading,
    commercialbox,
    userdata,
  },

  data() {
    return {
      distribution: this.$genericClass.distribution(),
      transport: this.$genericClass.transport(),
      airocean: this.$genericClass.airocean(),
      logistics: this.$genericClass.logistics(),
      specialservices: this.$genericClass.specialservices(),
      commercials: [],
      commercials_d: [],
      commercials_a: [],
      commercials_l: [],
      commercials_t: [],
      commercials_s: [],
      divisions: [],
      isMobile: false,
      commercialRequest: {
        color: "",
        item: [],
      },
      emptyItem: {
        nome: "",
        cognome: "",
        ruolo: "",
        telefono: "",
        cellulare: "",
        email: "",
      },
      isLoading: false,
    };
  },

  computed: {
    showCommercialRequest: function () {
      let tmp = this.$store.getters.GET_selectedCommercial;

      this.commercialRequest.item =
        this.$store.getters.GET_selectedCommercial.commercialSelected;
      this.commercialRequest.color =
        this.$store.getters.GET_selectedCommercial.color;

      return tmp.show;
    },
  },

  created() {
    this.isLoading = true;
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();

    let user = this.$GAUserAuth.user;

    MyFercamApi.GetCommercials(user.fCompanyCode, user.companyCode)
      .then((res) => {
        this.commercials = res.data;

        this.commercials_d = this.commercials.filter(
          (x) => x.divisione == this.distribution
        );
        this.commercials_a = this.commercials.filter(
          (x) => x.divisione == this.airocean
        );
        this.commercials_l = this.commercials.filter(
          (x) => x.divisione == this.logistics
        );
        this.commercials_t = this.commercials.filter(
          (x) => x.divisione == this.transport
        );
        this.commercials_s = this.commercials.filter(
          (x) => x.divisione == this.specialservices
        );

        // console.log(
        //   "commercials",
        //   this.commercials_d,
        //   this.commercials_s,
        //   this.commercials_a,
        //   this.commercials_l,
        //   this.commercials_t
        // );
        this.isLoading = false;
        //console.log("commercials_d", this.commercials_d[0]);
      })
      .catch((err) => {
        this.isLoading = false;
      });

    this.divisions = this.$genericClass.getProfileDivisions();
  },

  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  methods: {
    showUserData() {
      if (this.showCommercialRequest && this.isMobile) return false;
      else return true;
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    getClass(commercials, index) {
      var component_class = "";

      if (this.isMobile) {
        return "three-commercial";
      }

      if (commercials.length > 2) {
        component_class = "three-commercial";
      }
      if (commercials.length == 2) {
        component_class = "two-commercial";
      }
      if (commercials.length == 1) {
        component_class = "full-commercial";
      }
      return component_class;
    },
  },
};
</script>